export default "__VITE_ASSET__CqKL2DJ5__"